import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useMediaPopupStore = defineStore('mediaPopup', () => {
  // Heterogeneous list of media/post-like items (media, pins, deliverables, etc.) shown
  // in the media popup drawer. Consumers narrow this to their own shape as needed.
  const contextList = ref<unknown[] | null>(null);

  function setMediaContextList({ mediaContextList }: { mediaContextList: unknown[] | null }) {
    contextList.value = mediaContextList;
  }

  function clearMediaContextList() {
    contextList.value = null;
  }

  return {
    contextList,
    setMediaContextList,
    clearMediaContextList,
  };
});
